import { render, staticRenderFns } from "./ReceivableDetailContent.vue?vue&type=template&id=26ce5f3a&"
import script from "./ReceivableDetailContent.vue?vue&type=script&lang=js&"
export * from "./ReceivableDetailContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports